import { render, staticRenderFns } from "./EditEmailConf.vue?vue&type=template&id=2e40b1ae"
import script from "./EditEmailConf.vue?vue&type=script&lang=js"
export * from "./EditEmailConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports